import React, { useEffect } from "react";
import ModelCosts from "../pages/ModelCosts";
import "./ModelCostsModal.css";

interface Props {
  modelId: string;
  title?: string;
  onClose: () => void;
}

/**
 * Model maliyet ekranını (sipariş bazlı maliyet setleri, kalem ekle/düzenle/sil)
 * sayfaya gitmeden modal içinde açar. İçerik `ModelCosts` sayfasının gömülü
 * halidir; sayfanın kendi başlığı ve kırıntı gezinmesi CSS ile gizlenir.
 */
const ModelCostsModal: React.FC<Props> = ({ modelId, title, onClose }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      // İçteki ekleme/düzenleme modalı açıkken Escape onlara kalsın
      if (e.key === "Escape" && !document.querySelector(".mcm-panel .modal-overlay")) onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="mcm-overlay" onClick={onClose}>
      <div className="mcm-panel" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="mcm-head">
          <div>
            <span className="mcm-kicker">Maliyet yönetimi</span>
            <h2>{title || "Model maliyetleri"}</h2>
          </div>
          <button className="mcm-close" aria-label="Kapat" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6 6 18" /></svg>
          </button>
        </div>
        <div className="mcm-body">
          <ModelCosts modelId={modelId} onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

export default ModelCostsModal;
